import React from 'react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>{t('about.title')}</h1>
          <p>{t('about.subtitle')}</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="content-section">
            <h2>{t('about.mission')}</h2>
            <p>{t('about.mission_text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('about.story')}</h2>
            <p>{t('about.story_text')}</p>
            <p>{t('about.story_expansion')}</p>
          </div>

          <div className="content-section">
            <h2>{t('about.values')}</h2>
            <ul>
              <li><strong>{t('about.values_list.innovation')}</strong></li>
              <li><strong>{t('about.values_list.quality')}</strong></li>
              <li><strong>{t('about.values_list.collaboration')}</strong></li>
              <li><strong>{t('about.values_list.transparency')}</strong></li>
              <li><strong>{t('about.values_list.reliability')}</strong></li>
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('about.experience')}</h2>
            <h3>{t('about.experience_web.title')}</h3>
            <p>{t('about.experience_web.description')}</p>
            
            <h3>{t('about.experience_mobile.title')}</h3>
            <p>{t('about.experience_mobile.description')}</p>
            
            <h3>{t('about.experience_community.title')}</h3>
            <p>{t('about.experience_community.description')}</p>
            
            <h3>{t('about.experience_gaming.title')}</h3>
            <p>{t('about.experience_gaming.description')}</p>
          </div>

          <div className="content-section">
            <h2>{t('about.why_choose')}</h2>
            <ul>
              <li><strong>{t('about.why_choose_list.experienced_team')}</strong></li>
              <li><strong>{t('about.why_choose_list.proven_track')}</strong></li>
              <li><strong>{t('about.why_choose_list.comprehensive_services')}</strong></li>
              <li><strong>{t('about.why_choose_list.ongoing_support')}</strong></li>
              <li><strong>{t('about.why_choose_list.competitive_pricing')}</strong></li>
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('about.commitment')}</h2>
            <p>{t('about.commitment_text1')}</p>
            <p>{t('about.commitment_text2')}</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;

